module.exports = __webpack_public_path__ + "static/images/card.8b7d13a.png";